/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingPlatform } from './';
import {
    BillingPlatformFromJSON,
    BillingPlatformFromJSONTyped,
    BillingPlatformToJSON,
} from './';
import type { EProcurementPlatform } from './';
import {
    EProcurementPlatformFromJSON,
    EProcurementPlatformFromJSONTyped,
    EProcurementPlatformToJSON,
} from './';
import type { InvoicingModeResource } from './';
import {
    InvoicingModeResourceFromJSON,
    InvoicingModeResourceFromJSONTyped,
    InvoicingModeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvoicingSettingsUpdateRequest
 */
export interface InvoicingSettingsUpdateRequest {
    /**
     * 
     * @type {InvoicingModeResource}
     * @memberof InvoicingSettingsUpdateRequest
     */
    invoicingMode: InvoicingModeResource;
    /**
     * 
     * @type {boolean}
     * @memberof InvoicingSettingsUpdateRequest
     */
    isSubcontracting?: boolean;
    /**
     * 
     * @type {EProcurementPlatform}
     * @memberof InvoicingSettingsUpdateRequest
     */
    eprocPlatform?: EProcurementPlatform;
    /**
     * 
     * @type {BillingPlatform}
     * @memberof InvoicingSettingsUpdateRequest
     */
    billingPlatform?: BillingPlatform;
    /**
     * 
     * @type {string}
     * @memberof InvoicingSettingsUpdateRequest
     */
    extraInformation?: string;
}

/**
 * Check if a given object implements the InvoicingSettingsUpdateRequest interface.
 */
export function instanceOfInvoicingSettingsUpdateRequest(value: object): value is InvoicingSettingsUpdateRequest {
    if (!('invoicingMode' in value) || value['invoicingMode'] === undefined) return false;
    return true;
}

export function InvoicingSettingsUpdateRequestFromJSON(json: any): InvoicingSettingsUpdateRequest {
    return InvoicingSettingsUpdateRequestFromJSONTyped(json, false);
}

export function InvoicingSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicingSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoicingMode': InvoicingModeResourceFromJSON(json['invoicingMode']),
        'isSubcontracting': json['isSubcontracting'] == null ? undefined : json['isSubcontracting'],
        'eprocPlatform': json['eprocPlatform'] == null ? undefined : EProcurementPlatformFromJSON(json['eprocPlatform']),
        'billingPlatform': json['billingPlatform'] == null ? undefined : BillingPlatformFromJSON(json['billingPlatform']),
        'extraInformation': json['extraInformation'] == null ? undefined : json['extraInformation'],
    };
}

export function InvoicingSettingsUpdateRequestToJSON(value?: InvoicingSettingsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'invoicingMode': InvoicingModeResourceToJSON(value['invoicingMode']),
        'isSubcontracting': value['isSubcontracting'],
        'eprocPlatform': EProcurementPlatformToJSON(value['eprocPlatform']),
        'billingPlatform': BillingPlatformToJSON(value['billingPlatform']),
        'extraInformation': value['extraInformation'],
    };
}

